<template>
<SlotModal @close="$emit('closeModal')">
    <div class="merch-store__accept-buy-modal__wrapper">
        <div class="bug-modal__content">
            <p class="merch-store__accept-buy-modal__title">
                Заполните форму ниже или позвоните по телефону 5182/5185.
            </p>
            <textarea class="modal__input__text__input"
                      placeholder="Опишите проблему"
                      v-model="bugreport"></textarea>
        </div>
        <div>
            <button @click="sendReport"
                    class="primary-button bug-modal__content__loader">
                <Loader v-if="isLoading" />
                <span v-else>Подтвердить</span>
            </button>
            <span class="red-text absolute"
                  v-if="emptyInput">
                Заполните форму
            </span>
        </div>
    </div>
</SlotModal>
</template>
<script lang='ts'>
import { defineComponent, ref, computed, onMounted } from 'vue';
import SlotModal from '@/components/tools/modal/SlotModal.vue';
import Api from '@/utils/Api';
import { createMail } from "@/utils/createMail";
import { useUserData } from '@/stores/userData';
import { handleApiError, handleApiResponse } from '@/utils/apiResponseCheck';
import { useToast } from 'primevue/usetoast';
import { useToastCompose } from '@/composables/useToastСompose';
import Loader from '../Loader.vue';
import type { AxiosError } from 'axios';

export default defineComponent({
    components: {
        SlotModal,
        Loader
    },
    props: {},
    setup(_, { emit }) {
        const bugreport = ref<string>('');
        const isLoading = ref(false);
        const email = computed(() => useUserData().getUser.email);
        const toastInstance = useToast();
        const toast = useToastCompose(toastInstance);
        const emptyInput = ref(false);

        const sendReport = async () => {
            if (!email.value || !bugreport.value) return emptyInput.value = true;;
            isLoading.value = true;
            const mailText = createMail(bugreport.value, '', false);
            const body = {
                "sender": email.value,
                "reciever": '',
                "title": '',
                "text": mailText,
                "file_url": ''
            }
            try {
                const data = await Api.post('users/send_error', body)
                handleApiResponse(data, toast, 'trySupportError', 'bugReportSuccess')
            }
            catch (error) {
                handleApiError(error as AxiosError, toast)
            }
            finally { isLoading.value = false; emit('closeModal') }
        }

        return {
            bugreport,
            isLoading,
            emptyInput,
            sendReport
        }
    }
});
</script>